export default __webpack_public_path__ + "static/media/close-black-symbol.d05906e0.svg";